<template>
  <container>
    <!--<div class="subpage__cnt col-xl-10 offset-xl-1 text-center">-->
      <!--<p class="subpage-text">-->
        <!--New York is one of the most iconic cities in the world to live in, and also one of the most diverse. Start your-->
        <!--journey by living in student housing in Midtown, surrounded by world-famous.-->
        <!--<br><br>-->
        <!--Cities in the world to live in, and also one of the most diverse. Start your journey by living in student.-->
      <!--</p>-->
    <!--</div>-->
    <div class="subpage-list city-univercities" v-if="cityDetails">
      <div class="text-center mb-35">
        <div class="result-bracket__title">
          <span class="result-bracket__count">{{ cityDetails.universities.length }}</span> Üniversite Bulunuyor!
        </div>
      </div>
      <div class="flex-row">
        <router-link
          :to="{ name: 'University', params: { slug: university.slug }}"
          class="subpage-list__item"
          v-for="university in cityDetails.universities"
          :key="university.id">
          <uni-card :uni="university" />
        </router-link>
      </div>
    </div>
  </container>
</template>

<script>
import UniCard from '@/components/UniCard'
import { mapGetters } from 'vuex'
export default {
  name: 'CityDetailAbout',
  components: {
    UniCard
  },
  computed: {
    ...mapGetters(['cityDetails'])
  }
}
</script>

<style scoped>
.city-univercities .info-card{
  height: auto !important;
}
</style>
